import * as React from 'react'
import {
  IRequestContext,
  sanitizedRequestContextSelector
} from '../selectors/requestContext'
import { withLogger, ILogger } from '../context/withLogger'
import { connect } from 'react-redux'
import { IDetailPageState } from '../reducers'

interface IError {
  error: Error
  children?: JSX.Element
}

type StateProps = {
  requestContext: IRequestContext
}

const ErrorMessageHandlerWithContext = ({
  requestContext: { isInternal },
  logger,
  error,
  children
}: IError & ILogger & StateProps) => {
  logger.error(error)
  return isInternal ? <p>{error.stack}</p> : <>{children}</>
}

const mapStateToProps = (state: IDetailPageState): StateProps => ({
  requestContext: sanitizedRequestContextSelector(state)
})

const ErrorMessageHandler = withLogger(
  connect(mapStateToProps)(ErrorMessageHandlerWithContext)
)

export const tryCatch = <T extends {}>(
  fn: React.SFC<T>,
  customerNotification?: JSX.Element
) =>
  function(t: T) {
    try {
      return fn(t)
    } catch (error) {
      return (
        <ErrorMessageHandler error={error}>
          {customerNotification}
        </ErrorMessageHandler>
      )
    }
  }
